import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, configFeatureKey } from '../reducers/bonuses.reducer';

export const selectBonuses = createFeatureSelector<State>(configFeatureKey);

export const selectSelectedBonus = createSelector(selectBonuses, (state: State) => state.activeBonus);
